import { Ref, ref, watchEffect } from "vue";

export function awaitPromise<T>(
  promise: Promise<T>
): {
  result: Ref<T | undefined>;
  loading: Ref<boolean>;
  error: Ref<boolean>;
} {
  const result = ref<T | undefined>();
  const loading = ref(true);
  const error = ref(false);

  watchEffect(async () => {
    try {
      result.value = await promise;
      loading.value = false;
    } catch (e) {
      loading.value = false;
      error.value = true;
    }
  });

  return { result, loading, error };
}
